import { useTranslation } from 'react-i18next';

interface SeatsInUseProps {
  held: number;
  total: number;
}

/** "6 of 7 seats in use" with a bar filled to the seats held. */
export const SeatsInUse = ({ held, total }: SeatsInUseProps) => {
  const { t } = useTranslation();
  const percent = total > 0 ? Math.min(100, (held / total) * 100) : 0;

  return (
    <div className="flex flex-col gap-2">
      <p className="text-sm text-foreground">
        {t('SEATS_IN_USE_OF', { held, total, defaultValue: '{{held}} of {{total}} seats in use' })}
      </p>
      <div className="h-1.5 overflow-hidden rounded-full bg-grey-100 dark:bg-border" aria-hidden="true">
        <div className="h-full rounded-full bg-grey-900 dark:bg-true-white" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};
